import {clientService} from "../network/services/client.service";

export default {
  namespaced: true,
  state: {
    loading: false,
    errors: []
  },
  mutations: {
    SET_LOADING (state, payload) {
      state.loading = !!payload;
    },
    SET_ERRORS (state, payload) {
      state.errors = payload || [];
    }
  },
  actions: {
    async send (context, email) {
      context.commit('SET_LOADING', true);
      const response = await clientService.sendForgotRequest(email);
      context.commit('SET_ERRORS', response.errors);
      context.commit('SET_LOADING', false);
    },
    async update (context, {email, password, code}) {
      context.commit('SET_LOADING', true);
      const response = await clientService.changePasswordWithCode({email, password, code});
      context.commit('SET_ERRORS', response.errors);
      context.commit('SET_LOADING', false);
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/forgot-password.store.js